"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@/components/ui/dropdown-menu"
import { cn } from "@/lib/utils"

export type MenuAppearance = "legacy" | "zestlife"

/**
 * Matches the old MUI CustomizedMenu paper: 20px radius, white, subtle ring
 * shadow, 4px vertical list padding, overflow visible (lets the embedded org
 * switcher panel escape the menu bounds like the MUI paper did).
 */
const LEGACY_CONTENT_CLASSES =
  "z-[1300] w-auto max-h-none min-w-[180px] overflow-visible rounded-[20px] bg-white px-0 py-1 font-roboto tracking-normal text-[rgb(55,65,81)] shadow-[0_0_0_1px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] ring-0 duration-200"

/** Matches ZESTLIFE_MENU_PAPER_SX: 16px radius, hairline border, soft shadow. */
const ZESTLIFE_CONTENT_CLASSES =
  "z-[1300] w-auto min-w-[232px] max-w-[400px] rounded-[16px] border-[0.5px] border-solid border-[rgba(0,0,0,0.12)] bg-white p-0 font-roboto tracking-normal text-[#092C3C] shadow-[0_8px_32px_rgba(0,0,0,0.10),0_2px_8px_rgba(0,0,0,0.06)] ring-0 duration-200"

/**
 * Nav bar dropdown. Radix couples trigger and content, so unlike the old MUI
 * anchorEl pattern the trigger element is passed in and rendered inside the
 * root (side="bottom" + align="end" + sideOffset 8 replicates the MUI
 * bottom-right anchor / top-right transform origin with 8px paper margin).
 */
export default function Menu({
  trigger,
  children,
  appearance = "legacy",
  open,
  onOpenChange,
  contentClassName,
}: {
  trigger: React.ReactElement
  children?: React.ReactNode
  appearance?: MenuAppearance
  open?: boolean
  onOpenChange?: (open: boolean) => void
  /** Merged last onto the content classes (e.g. a height cap + scrolling). */
  contentClassName?: string
}) {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        sideOffset={8}
        className={cn(
          appearance === "zestlife"
            ? ZESTLIFE_CONTENT_CLASSES
            : LEGACY_CONTENT_CLASSES,
          contentClassName,
        )}
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
